import React from "react";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import { brandName } from "../../../../Constants/content";
import {
  primaryColor,
  secondaryColor,
  textDarkColor,
} from "../../../../Constants/Colors";
import topbg from "../../../../Assets/Images/Works/Clip-top.png";
import btmbg from "../../../../Assets/Images/Works/Clip-bottom.png";
import projectMob1 from "../../../../Assets/Images/Works/Mahalakshmi/mob1.png";
import projectMob2 from "../../../../Assets/Images/Works/Mahalakshmi/mob2.png";
import projectLap from "../../../../Assets/Images/Works/Mahalakshmi/lap.png";
import star from "../../../../Assets/Images/Works/Mahalakshmi/start.png";
import clientGoalsImg from "../../../../Assets/Images/Works/Mahalakshmi/ClientGoals.png";
import keyChallengesImg from "../../../../Assets/Images/Works/Mahalakshmi/KeyChallenge.png";
import computerIcon from "../../../../Assets/Images/Works/Mahalakshmi/icons/computer.png";
import mobileIcon from "../../../../Assets/Images/Works/Mahalakshmi/icons/mobile.png";
import linkIcon from "../../../../Assets/Images/Works/Mahalakshmi/icons/link.png";
import paintIcon from "../../../../Assets/Images/Works/Mahalakshmi/icons/paint.png";
import folderIcon from "../../../../Assets/Images/Works/Mahalakshmi/icons/folder.png";
import { FaApple } from "react-icons/fa";
import GetInTouch from "../../../../Components/GetInTouch";
import googlePlayIcon from "../../../../Assets/Images/Works/Mahalakshmi/icons/icons8-google-play-16.png";
import mmsProject from "../../../../Assets/Images/Works/Mahalakshmi/mms-project.png";
import chain from "../../../../Assets/Images/Works/Mahalakshmi/icons/chain.png"

const Mahalakshmi = () => {
  const clientGoals = [
    {
      id: 1,
      title: "Modernize booking and reporting",
    },
    {
      id: 2,
      title: "Improve patient engagement via mobile & web",
    },
    {
      id: 3,
      title: "Reduce manual workload for staff",
    },
    {
      id: 4,
      title: "Ensure secure, 24/7 report access",
    },
    {
      id: 5,
      title: "Boost search visibility and digital reach",
    },
  ];
  const keyChallenges = [
    {
      id: 1,
      title: "Manual, paper-based workflows with no digital tracking",
    },
    {
      id: 2,
      title: "Patients had to visit the center to get reports",
    },
    {
      id: 3,
      title: "CNo mobile app or optimized website for service discovery",
    },
    {
      id: 4,
      title: "Inefficient internal operations and report uploads",
    },
  ];
  const solutions = [
    {
      id: 1,
      title: "Website Transformation",
      description:
        "We built a fully responsive, SEO-optimized website designed for both desktop and mobile users. It includes smart test listings, quick booking CTAs, and intuitive contact forms to improve patient engagement and drive conversions.",
      icon: computerIcon,
    },
    {
      id: 2,
      title: "Mobile App Development",
      description:
        "A dedicated Android app enables patients to book lab tests or schedule home collections in just a few taps. It features push notifications for real-time updates and secure login to view and download reports anytime.",
      icon: mobileIcon,
    },
    {
      id: 3,
      title: "Backend CMS for Staff",
      description:
        "To streamline internal operations, we delivered a role-based admin dashboard that allows staff to upload reports, manage appointments, control test listings, and track status—all while maintaining security with time-limited download access.",
      icon: folderIcon,
    },
    {
      id: 4,
      title: "Patient-Centric UI/UX",
      description:
        "We focused on clean, card-based layouts, sticky CTAs, and high-contrast design elements to ensure a smooth, accessible experience for users across all age groups and devices.",
      icon: paintIcon,
    },
    {
      id: 5,
      title: " Integrations & SEO Boost",
      description:
        "We integrated SMS/email APIs for instant alerts and applied schema markup, meta tags, and CDN optimization for improved SEO performance and lightning-fast load times—future-proofing their digital reach.",
      icon: linkIcon,
    },
  ];
  return (
    <Container className="mt-2">
      <div className="text-center position-relative works-page-header-bg">
        <Image src={topbg} className="top-bg-img" />

        <Button
          variant="primary"
          style={{
            backgroundColor: "#007bff",
            border: "none",
            borderRadius: "20px",
            padding: "5px 20px",
            fontSize: "14px",
          }}
        >
          Works
        </Button>
        <h2 className="my-3" style={{ color: primaryColor }}>
          Mahalakshmi Diagnostics
        </h2>
        <p>Digitally Reimagining Chennai’s Trusted Diagnostic Brand</p>
        <h5 className="my-2">
          Website + Android App | Designed & Built by{" "}
          <span
            style={{
              background: `linear-gradient(90deg, ${primaryColor}, ${secondaryColor})`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontWeight: "bold",
            }}
          >
            {brandName}
          </span>
        </h5>
        <div className="d-flex justify-content-center gap-4 mt-4">
          <Button variant="outline-dark" className="rounded-pill">
            Website
          </Button>
          <Button variant="outline-dark" className="rounded-pill">
            Mobile Application
          </Button>
        </div>
        <Image className="bottom-bg-img" src={btmbg} />
      </div>
      <Row>
        <Col md={11} className="mx-auto my-4">
          <h2 className="text-center" style={{ color: primaryColor }}>
            {" "}
            Project Overview
          </h2>
          <p
            className="text-justify text-center"
            style={{ lineHeight: "2", fontSize: "17px" }}
          >
            Mahalakshmi Diagnostics, a well-established healthcare provider in
            Chennai, approached us to transform their traditional walk-in model
            into a fully digital experience. Known for accurate results and
            patient trust, their lack of digital tools was holding them back
            from modern growth.
          </p>
        </Col>
        <Col>
          <div className="text-center">
            <h4
              className="p-1 d-inline-block fst-italic"
              style={{
                color: primaryColor,
                backgroundColor: " #e2f2f9ff",
                textShadow: "1px 1px 3px rgba(0, 0, 0, 0.3)",
                textTransform: "capitalize",
              }}
            >
              Our goal was to build a seamless digital ecosystem where patients
              could:
            </h4>
          </div>
          <ul className="list-unstyled d-flex flex-lg-row flex-column gap-3 justify-content-center my-4 ms-5 ms-lg-0">
            <li>📅 Book lab tests online</li>
            <li>🧪 Schedule home sample collections</li>
            <li>📥 Access reports remotely</li>
            <li>📲 Interact via mobile and web</li>
          </ul>
          <p className="text-center">
            This wasn’t just a tech upgrade. It was a complete digital
            reinvention focused on ease, accessibility, and efficiency.
          </p>
        </Col>
      </Row>
      <Row className="d-flex justify-content-center align-items-center my-5 ">
        <Col xs={3} className="position-relative">
          <Image
            src={star}
            className="star-bg-img"
            style={{ top: "0%", left: "0%", width: "auto", zIndex: "-1" }}
          />
          <Image
            src={star}
            className="star-bg-img"
            style={{ bottom: "0%", left: "10%", width: "auto", zIndex: "-1" }}
          />
          <Image
            src={star}
            className="star-bg-img"
            style={{ top: "0%", right: "0%", width: "auto", zIndex: "-1" }}
          />
          <Image src={projectMob2} fluid />
        </Col>
        <Col xs={6} className="position-relative">
          <Image
            src={star}
            className="star-bg-img"
            style={{ top: "0%", right: "0%", width: "auto", zIndex: "-1" }}
          />
          <Image src={projectLap} fluid />
        </Col>
        <Col xs={3} className="position-relative">
          <Image
            src={star}
            className="star-bg-img"
            style={{ bottom: "0%", left: "20%", width: "auto", zIndex: "-1" }}
          />
          <Image
            src={star}
            className="star-bg-img"
            style={{ top: "0%", right: "0%", width: "auto", zIndex: "-1" }}
          />
          <Image src={projectMob1} fluid />
        </Col>
      </Row>
      <Row className="">
        <Col xs={12} md={7} lg={7} xl={6} className="px-3 px-lg-5 my-2 my-md-5">
          <Button
            className="rounded-pill"
            style={{ backgroundColor: primaryColor, border: "none" }}
          >
            Client Goals
          </Button>

          <ul className="list-unstyled">
            {clientGoals.map((goal, index) => {
              return (
                <li
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    borderLeft: `5px solid ${primaryColor}`,
                    borderRight: "5px solid rgb(201, 203, 204)",

                    borderRadius: "10px",
                    boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.2)",
                  }}
                  className="p-1 p-lg-2 mt-2 mt-lg-3"
                >
                  <span
                    className="pe-3"
                    style={{
                      background: "linear-gradient(to left, #1e3b8a, #4fa8f1)",
                      WebkitMaskImage:
                        "url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 fill=%22black%22 viewBox=%220 0 512 512%22><path d=%22M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.248-22.627 0L216 308.373l-70.059-70.059c-6.248-6.248-16.379-6.248-22.627 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.248 6.248 16.379 6.248 22.627 0z%22/></svg>')",
                      WebkitMaskRepeat: "no-repeat",
                      WebkitMaskSize: "cover",
                      display: "inline-block",
                      width: "20px",
                      height: "20px",
                    }}
                  ></span>
                  {goal.title}
                </li>
              );
            })}
          </ul>
        </Col>
        <Col xs={9} md={5} lg={5} xl={4} className="m-auto">
          <Image src={clientGoalsImg} fluid />
        </Col>
      </Row>
      <Row className="mb-5 mt-3 mt-md-0">
        <Col
          xs={9}
          md={5}
          lg={5}
          xl={4}
          className="m-auto d-none d-md-flex justify-content-center"
        >
          <Image src={keyChallengesImg} fluid />
        </Col>
        <Col xs={12} md={7} lg={7} xl={6} className="px-3 px-lg-5">
          <Button
            className="rounded-pill"
            style={{ backgroundColor: primaryColor, border: "none" }}
          >
            key Challenges
          </Button>

          <ul className="list-unstyled">
            {keyChallenges.map((Challenge, index) => {
              return (
                <li
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    borderLeft: `5px solid ${primaryColor}`,
                    borderRight: "5px solid rgb(201, 203, 204)",

                    borderRadius: "10px",
                    boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.2)",
                  }}
                  className="p-1 p-lg-2 mt-2 mt-lg-3 "
                >
                  <span
                    className="pe-3"
                    style={{
                      background: "linear-gradient(to left, #1e3b8a, #4fa8f1)",
                      WebkitMaskImage:
                        "url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 fill=%22black%22 viewBox=%220 0 512 512%22><path d=%22M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.248-22.627 0L216 308.373l-70.059-70.059c-6.248-6.248-16.379-6.248-22.627 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.248 6.248 16.379 6.248 22.627 0z%22/></svg>')",
                      WebkitMaskRepeat: "no-repeat",
                      WebkitMaskSize: "cover",
                      display: "inline-block",
                      width: "20px",
                      height: "20px",
                    }}
                  ></span>
                  {Challenge.title}
                </li>
              );
            })}
          </ul>
        </Col>
        <Col
          xs={9}
          md={5}
          lg={5}
          xl={4}
          className="m-auto d-flex justify-content-center d-md-none"
        >
          <Image src={keyChallengesImg} fluid />
        </Col>
      </Row>
      <Row>
        <h2 className="text-center" style={{ color: primaryColor }}>
          Our Solution
        </h2>
        <p className="text-center">
          To modernize Mahalakshmi Diagnostics’ digital presence, we built a
          fully responsive, SEO-friendly website with categorized test listings,
          quick booking CTAs, and simple contact forms—making it easy for users
          to explore services and take action on any device.
        </p>
        <Col>
          {solutions.map((solution, index) => (
            <Row key={index} className="my-4">
              <Col xs={12} md={11} lg={10} className="mx-auto">
                <Row
                  className="d-flex justify-content-center align-items-center mx-auto"
                  style={{ borderBottom: `1px solid ${primaryColor}` }}
                >
                  <Col xs={2} sm={1}>
                    <Image src={solution.icon} />
                  </Col>
                  <Col xs={9} sm={7} md={2} className="">
                    <h5
                      style={{ color: primaryColor }}
                      className="d-none d-lg-flex"
                    >
                      {solution.title}
                    </h5>
                    <h6
                      style={{ color: primaryColor }}
                      className="d-flex d-lg-none"
                    >
                      {solution.title}
                    </h6>
                  </Col>
                  <Col xs={12} sm={12} md={8} lg={9}>
                    <p
                      className="text-justify ms-3"
                      style={{ fontSize: "14px" }}
                    >
                      {solution.description}
                    </p>
                  </Col>
                </Row>
              </Col>
            </Row>
          ))}
        </Col>
      </Row>
      <div className="mt-5">
        <h2 style={{ color: primaryColor }} className="text-center">
          The Results
        </h2>
        <p className="text-center">
          Our solution delivered tangible outcomes within weeks of launch:
        </p>
        <Row className="results-stats mx-auto my-5">
          {/* Top Left */}
          <Col
            xs={4}
            className="text-center py-4"
            style={{
              borderRight: `2px solid ${primaryColor}`,
              borderBottom: `2px solid ${primaryColor}`,
            }}
          >
            <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>100%</h2>
            <p className="text-muted mb-0">paperless operations</p>
          </Col>

          {/* Top Right */}
          <Col
            xs={4}
            className="text-center py-4"
            style={{
              borderBottom: `2px solid ${primaryColor}`,
              borderRight: `2px solid ${primaryColor}`,
            }}
          >
            <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>24/7</h2>
            <p className="text-muted mb-0">secure report access</p>
          </Col>

          {/* Bottom Left */}
          <Col
            xs={4}
            className="text-center py-4"
            style={{
              borderBottom: `2px solid ${primaryColor}`,
            }}
          >
            <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>Increased</h2>
            <p className="text-muted mb-0">online test bookings</p>
          </Col>

          {/* Bottom Right */}
          <Col
            xs={4}
            className="text-center py-4"
            style={{
              borderRight: `2px solid ${primaryColor}`,
            }}
          >
            <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>Reduced</h2>
            <p className="text-muted mb-0">phone traffic for support</p>
          </Col>
          <Col
            xs={4}
            className="text-center py-4"
            style={{
              borderRight: `2px solid ${primaryColor}`,
            }}
          >
            <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>Stronger</h2>
            <p className="text-muted mb-0">online search visibility</p>
          </Col>
          <Col xs={4} className="text-center py-4">
            <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>Elevated</h2>
            <p className="text-muted mb-0">patient satisfaction & loyalty</p>
          </Col>
        </Row>
      </div>

      <Container className="my-4">
        <Row
          className="align-items-center justify-content-between"
          style={{
            backgroundImage: "linear-gradient(135deg, #014F6F, #0297D5)",
            borderRadius: "12px",
            border: "6px solid #ade2f9ff",
          }}
        >
          {/* Left Side Content */}
          <Col md={6} lg={5} className="d-flex flex-column gap-lg-3 gap-1 py-2 py-lg-0">
            <h4 className=" fw-bold text-light"><Image width={20} height={20} src={chain} />&nbsp; Project Links</h4>
            <p className=" text-light">
              <strong>Website:</strong>{" "}
              <a
                href="https://mahalakshmidiagnostics.com"
                target="_blank"
                className="text-light"
                rel="noreferrer"
              >
                mahalakshmidiagnostics.com
              </a>
            </p>

            <p className="text-light">
              <strong>Mobile App:</strong> Available Now On
            </p>

            <div className="d-flex gap-3">
              <Button
                style={{
                  background: "linear-gradient(to top, #025191ff, #13abecff)",
                  color: "#fff",
                  fontSize:'12px'
                }}
                className="d-flex align-items-center gap-1 gap-md-2 rounded-3 px-2 px-md-3 "
              >
                <Image src={googlePlayIcon} /> Download Now
              </Button>
              <Button
                style={{
                  background: "linear-gradient(to top, #025191ff, #13abecff)",
                  color: "#fff",
                   fontSize:'12px'
                }}
                className="d-flex align-items-center gap-1 gap-md-2 rounded-3 px-2 px-md-3 "
              >
                <FaApple /> Download Now
              </Button>
            </div>

            <p className="text-light mb-0">
              Patient Portal: Secure Login For Test Booking, Report Access &
              Status Tracking
            </p>
          </Col>

          {/* Right Side Image */}
          <Col md={6} lg={7} className="p-0 m-0">
            <Image
              src={mmsProject}
              alt="Project Preview"
              className="rounded"
              fluid
            />
          </Col>
        </Row>
      </Container>

      <GetInTouch
        radius={60}
        description="Leverage our expertise to transform your digital presence and elevate your brand."
        bgColor="light"
        borderColor={secondaryColor}
        textColor={primaryColor}
        subTextColor={primaryColor}
        circleTextColor={textDarkColor}
      />
    </Container>
  );
};

export default Mahalakshmi;
